import { css } from "lit-element";

//language=CSS
export const style = css`
	:host {
		display: block;
	}
    
    :host svg {
        display: block;
        margin: auto;
        width: var(--sw-icon-width, 16px);
        height: var(--sw-icon-height, auto);
    }
	
    :host svg,
	:host path {
		color: var(--sw-icon-color, var(--app-primary, black));
		fill: var(--sw-icon-color, var(--app-primary, black));
	}
`;
